export default "assets/images/flags/es-65ebb5d4.svg";